import { render, staticRenderFns } from "./StakingMetadata.vue?vue&type=template&id=a169a982&scoped=true&"
import script from "./StakingMetadata.vue?vue&type=script&lang=ts&"
export * from "./StakingMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./StakingMetadata.vue?vue&type=style&index=0&id=a169a982&scoped=true&lang=scss&"
import style1 from "./StakingMetadata.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a169a982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
